import {Component, Input} from '@angular/core';
import {ControllerComponent} from '../../../Controller/controller-component';
import {EventDto} from '../../../../Models/Events/event.interface';

@Component({
  selector: 'app-event-data-block',
  templateUrl: './event-data-block.component.html',
  styleUrls: ['./event-data-block.component.scss'],
  standalone: false
})
export class EventDataBlockComponent extends ControllerComponent {
  @Input() event!: EventDto;
}
